export default {
    contact: {
        title: 'Contact Us',
        description:
            'If you have a question about our features, datasets, usage, or want a demo, or anything else, our team is ready to help.',
        contactPhone: 'Contact Phone',
        links: [
            {
                title: 'Linkedin',
                link: 'https://linkedin.com',
            },
            {
                title: 'Facebook',
                link: 'https://facebok.com',
            },
        ],
    },
};
